export const daoResourceMock = [
  {
      "resource_id": "b66f2473-af2f-461c-9fe3-63bdfd5af2c2",
      "name": "BrightID",
      "description": "DAO-governed, Bright ID is a social-graph identity network that pledges to store no personal data. It applies peer evaluatation to identify trusted prospective members as unique users of BrightID uesr dapps.",
      "main_url": "https://www.brightid.org/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-brightID.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "fa74b7d1-5755-4acc-a226-88535345d741",
      "name": "Collab.Land",
      "description": "Collab.Land offers integrated identification-as-human services on community social platforms, and management of such membership permissions according to tokenized parameters.",
      "main_url": "https://collab.land/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Collabland.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "76cf9f5c-317b-4ec3-b689-660fd5661223",
      "name": "Common Ground",
      "description": "Common Ground is a Web3-native communication platform for individuals and communities. Featuring a reach onboarding layer, It serves human-identified 0x addresses with self-owned social experience and organizing tools including security, multimidia cords, roles, moderation, voting, and more.",
      "main_url": "https://www.commonground.cg/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/CoomonGround-logo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "2705d52e-df10-456e-b178-acd2149f8079",
      "name": "Coordinape",
      "description": "Coordinape is a tool for distributing individual rewards for contribution in a collective effort, based on peer judgement. A yearn.finance project, it currently serves grant-making and work payments.",
      "main_url": "https://coordinape.com ",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Coordinape.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "71438455-6692-448c-9751-33990165c7f6",
      "name": "DaoLens",
      "description": "DAOLens is a free tool deck for DAO onboarding and management with seamless web3 integration. It offers custom, gated onboarding flows, knowledge centers, analytics, and an admin panel integrating community tasks, contributions & contributor profiles, payments, discussions and more.",
      "main_url": "https://www.daolens.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/DaoLens.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "f82b185e-cbae-42b4-9133-0340efe2f6e0",
      "name": "DeepDAO",
      "description": "DeepDAO collects and organizes a variety of quantitative and qualitative data about DAOs governance, their structure, people and decision-making. It currently serves interactive data dashboards, project descriptions, a DAO Tools go-to and a governerds' discord channel.",
      "main_url": "https://deepdao.io",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-DeepDao.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "a4767b91-ecb1-450e-b707-3115ceaacf48",
      "name": "ENS",
      "description": "The Ethereum Name Service is the provider of unique, NFT name.eth and other .blockchain addresses, which are widely used for Web3 identification. Its DAO is currently heading full governance by the community of .eth holders.",
      "main_url": "https://ens.domains/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-ENS.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "a808543c-422f-4155-ae8a-b58ff0dadca0",
      "name": "EtherMail",
      "description": "EtherMail is an e-mail service for blockchain wallets, building anonymous and encrypted communication among Web3 and Web2 addresses. Its targeted, tokenized mailing products may be triggered by on-chain events, and reward users for permitting reputation-based paid content.",
      "main_url": "https://ethermail.io/",
      "logo": "https://ethermail.io/images/logos/logo_ethermail_horizontal_primarydark.svg",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "e8f0e4b5-bc85-4edc-a7d2-b36fe59cbc3e",
      "name": "Guild",
      "description": "Guild is an Agora Space product which facilitates the setup of token-gated Discord channels and roles, based on ownership of cross-chain, fungible and non-fungible tokens (NFTs).",
      "main_url": "https://alpha.guild.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Guild.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "79cd5b4f-d926-45b0-abda-c2b5798ad8aa",
      "name": "Hats Protocol",
      "description": "Hats are programmable roles (represented on-chain as NFTs) that can provide the \"wearer\" with on-chain and off-chain permissions including workspace access, multisig signing authority, voting rights, and more. Hats can be granted, claimed, or revoked based on automatable eligibility criteria.",
      "main_url": "https://www.hatsprotocol.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/hats+hat+757x157+with+margin1.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "2abc6687-6335-4a3e-860a-a68b0d70a792",
      "name": "IDX",
      "description": "IDX is a decentralized Identity protocol for individuals to own, cultivate, permission and use their unified digital identities at will. It is part of Credify, which facilitates commercial use of such data.",
      "main_url": "https://idx.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-IDX.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "b341eda4-f367-4eb8-81fc-894a4d604488",
      "name": "Lomads",
      "description": "Lomads is an operations and finance management dashboard for web3 organizations. It serves transactions workflow automation (e.g., bounties, recurring / batch / milestone-based payments); and mints organizations' Soul-Bound Tokens, with applicable roles & permissions across integrated Web2 / Web3 apps.",
      "main_url": "https://www.lomads.co/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Lomads_DeepDAO.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "c7828cc4-3f41-4013-9823-b6a810e786a1",
      "name": "Mailchain",
      "description": "Mailchain is a platform to send and receive messages directly between blockchain wallets. It allows cross-protocol communication, with user-owned mailbox and messages (1:1, 1:many), password, end-to-end encryption and decentralized storage for enhanced privacy.",
      "main_url": "https://mailchain.com/",
      "logo": "https://uploads-ssl.webflow.com/6193af32c4bb83588771612b/63163cdf369f8ad33461205d_mc-logo.svg",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "59f84b9e-38d3-11ed-a261-0242ac120002",
      "name": "Metopia",
      "description": "Metopia sets up NFT-based identity and governance infrastructure for Web3. Currently in Alpha, it serves permissionless user profiles with incentivized Web2, Web3 résumé, and users' NFT-governed DAOs including reputation incentives, dashboards and ecosystem integrations.",
      "main_url": "https://metopia.xyz/",
      "logo": "https://metopia.oss-cn-hongkong.aliyuncs.com/logo.svg",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "3d3f628d-63d7-42d1-bfd6-a12ae2b2aebf",
      "name": "POAP",
      "description": "POAP introduces a decentralized network of Identity verification that relies on individuals' combined collections of tokened Proofs of Attendance in events hosted by verified POAP partners. ",
      "main_url": "https://poap.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Poap.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "f4d48733-da0c-4a60-ac8b-88627f271eac",
      "name": "Proof of Humanity",
      "description": "Proof of Humanity is a network of the Kleros project that registers humans upon personal identifications and verified vouching. Thus proofed humans join PoH membership and are streamed Basic Human Income tokens. ",
      "main_url": "https://www.proofofhumanity.id/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Humanity.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "4d39b72b-e8c2-4a04-9a71-d3b880e686ec",
      "name": "Rabbithole",
      "description": "Rabbithole cooperates with web3 projects to reward new users for constructive participation in project dapps / platforms. Users learn, earn and build a verified resume', projects gain discovery and involvement. ",
      "main_url": "https://rabbithole.gg/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-RabbitHole.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "678f8998-d2d5-4e9e-90ee-290215b2eb5d",
      "name": "rep3",
      "description": "Rep3 does credentialing for communities. User communities custom-mint their membership NFTs, with attached NFT badges noting ongoing activities and structures like roles, payments, access, and beyond. Added governance & socials integrations, the badges grid becomes a cross-functional organizing tool.",
      "main_url": "https://rep3.gg/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/rep3logo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "48b97478-d65d-4577-8ea9-592dcdf11dd6",
      "name": "Spect",
      "description": "Spect creates advanced workflows for DAOs. Its flexible no-code setup Forms integrate flow content, roles, milestones & rewards with relevant 0x addresses, and instantiate the needed smart contracts. Spect leverages its user profiles' documented resume' towards system sybil resistance.",
      "main_url": "https://spect.network/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Spect-logo3.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "bd4dcb6e-467d-4585-b005-a063c73ff2c7",
      "name": "Unika",
      "description": "Unika is decentralized anonymous identity protocol. It provides privacy-preserving sybil-resistant user verification. Thus, upon dApp request and user's consent, Unika checks users’ eligibility and uniqueness. User's privacy is saved by delivering only yes/no answers about the user to dApp.",
      "main_url": "https://unika.network/main",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Unika-logo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 43,
      "type": "category"
  },
  {
      "resource_id": "013c8020-2a2a-4adb-8503-65c2bb719edd",
      "name": "Ceramic",
      "description": "Ceramic is a decentralized network to hash-store, access, manage and interact between mutable data streams over IPFS, including custom revrtieval functions, Web3 identificatoin integrations and app-building.",
      "main_url": "https://ceramic.network/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Ceramic.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 6,
      "type": "category"
  },
  {
      "resource_id": "a4767b91-ecb1-450e-b707-3115ceaacf48",
      "name": "ENS",
      "description": "The Ethereum Name Service is the provider of unique, NFT name.eth and other .blockchain addresses, which are widely used for Web3 identification. Its DAO is currently heading full governance by the community of .eth holders.",
      "main_url": "https://ens.domains/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-ENS.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 6,
      "type": "category"
  },
  {
      "resource_id": "c9ab8812-38d2-11ed-a261-0242ac120002",
      "name": "Grindery",
      "description": "Grindery is a middleware Web3 automation tool set to connect dApps and protocols for seamless cross-chain, web2 <> web3 exchange of data and services. Beta incubated by Binance Labs and seeded by Layer1 & 2 blockchains, its initial focus is DAO payouts & payroll.",
      "main_url": "https://www.grindery.io/",
      "logo": "https://www.grindery.io/hs-fs/hubfs/grindery-logo.png?width=147&name=grindery-logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 6,
      "type": "category"
  },
  {
      "resource_id": "d131f3a6-f9e6-4c2a-9a9a-aceca369a60c",
      "name": "IPFS",
      "description": "The InterPlanetary File System is a protocol network for a Web3 decentralized, resillient and private file storage & access.",
      "main_url": "https://ipfs.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-IPFS.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 6,
      "type": "category"
  },
  {
      "resource_id": "55fe57a8-6ff3-4ffa-9082-2eeff0f020a3",
      "name": "Kirobo",
      "description": "Kirobo develops decentralized applications for safer management of crypto assets. Set to enhance transaction validity and clarity and to reduce human errors, it serves personalized, non-custodian, DeFi-plugged Vaults with user-set wallets & passwords and retrieval functions.",
      "main_url": "https://www.kirobo.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Logos_Tools_Kirobo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 6,
      "type": "category"
  },
  {
      "resource_id": "55e9f0d1-e9dd-42cc-82c5-d1fbef9a16ff",
      "name": "Muse DAO",
      "description": "Muse DAO is an NFT venture builder DAO focused on building decentralized applications to further the NFT space. Its dapps - currently still unaudited (Aug. 2023) - serve a swift dapp building UI, open & liquid NFT minting, NFT DeFi operations, and more.",
      "main_url": "https://musedao.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Muse+dao+-+tool+logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 6,
      "type": "category"
  },
  {
      "resource_id": "12c511de-4990-41ce-a91a-9b2139335163",
      "name": "ADAM Vault",
      "description": "Adam Vault is an omni-chain decentralized treasury management system. DAO-governed, its codeless platform includes DAO member accounts, budget governance, delegated team authority over designated budgets, and a virtual credit card for real-world payments.",
      "main_url": "https://adamvault.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/adam_tool_logo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "80ebeba1-613d-4884-bfa6-f256188c7fc9",
      "name": "Bulla Network",
      "description": "Bulla Network is a multi-chain protocol for blockchain credit and accounting built atop Gnosis Safe. It produces permissionless P2P financial Claims, and leverages those towards scalable invoicing, payments management and financial reporting for individuals and organizations. (not audited)",
      "main_url": "https://bulla.network/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/BullaNetwork.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "68339a6d-9491-4dd6-b747-c2d608459408",
      "name": "Chelo",
      "description": "Chelo develops ready-to-deploy financial tools to help DAOs attract, retain, and support their community. It facilitates collateralized loans to DAO members, uncollateralized loans to top contributors, peer-to-peer saving and borrowing (ROSCAs) and forthcoming DAO invoices.",
      "main_url": "https://chelo.fi/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Chelo.jpg",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "be2cb3bd-cac0-446c-b2a6-2e6dee4e2ace",
      "name": "CoinShift",
      "description": "Coinshift (previously: Multisafe) is a treasury management platform for DAOs and crypto-native companies. Operating on users' Gnosis Safes, it currently serves ongoing, team and mass payments, direct swaps, gas-saving integrations, and asset risk assessment in collaboration with the Credmark project.",
      "main_url": "https://coinshift.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Coinshift.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "2705d52e-df10-456e-b178-acd2149f8079",
      "name": "Coordinape",
      "description": "Coordinape is a tool for distributing individual rewards for contribution in a collective effort, based on peer judgement. A yearn.finance project, it currently serves grant-making and work payments.",
      "main_url": "https://coordinape.com ",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Coordinape.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "9dcbb660-ec00-4275-b769-c2d57c885951",
      "name": "Enzyme",
      "description": "Enzyme is a council-led DAO controlling the Enzyme protocol for assets management, that is based on ready-made and user-strategized investment vaults. It offers DAOs a set of flexible capabilities to run their treasuries, currently leaning towards high-risk DeFi.",
      "main_url": "https://enzyme.finance//",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Enzyme.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "b341eda4-f367-4eb8-81fc-894a4d604488",
      "name": "Lomads",
      "description": "Lomads is an operations and finance management dashboard for web3 organizations. It serves transactions workflow automation (e.g., bounties, recurring / batch / milestone-based payments); and mints organizations' Soul-Bound Tokens, with applicable roles & permissions across integrated Web2 / Web3 apps.",
      "main_url": "https://www.lomads.co/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Lomads_DeepDAO.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "4041aa10-bfa5-454e-bd1d-b3037ec64f84",
      "name": "Multis",
      "description": "Multis is a financial management application for DAOs. \nBuilt on Gnosis Safe, Multis accounts serve monitoring, collaboration, analysis and accountancy for multiple wallets across multiple blockchains. It expects to launch debit cards and USD exchange for US-based DAOs in July 2022.",
      "main_url": "https://multis.co/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Logos_Tools_Multis.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "e77d5e8e-7d7c-44b3-ba02-287b602e15d8",
      "name": "Nexus Mutual",
      "description": "Nexus Mutual supplies on-chain insurance through liquidity pools and decentralized validation of customers' claims. Governed by permissioned NXM token holders, it currently covers smart contracts risks and aims further.",
      "main_url": "https://nexusmutual.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-NExus.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "16ad0e7e-e3c5-4ab0-815b-0ecdeaab5e0d",
      "name": "Octav",
      "description": "Octav is a web3 treasury management, analytics tool and on-chain data provider. It turns the full data of user accounts into live portfolio boards, integrative reports and API endpoints, tagged and tailored for easy management and official reporting.",
      "main_url": "https://octav.fi/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Octav.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "6a74822e-14a6-44b1-8858-efb4f4529860",
      "name": "Palmera",
      "description": "Palerma is a framework for simple, visualized DAO setup & management built atop Gnosis Safe integrations, modules, and hierarchies. Currently in alpha, it develops flexible structures for asset governance, role- and member-based permissions, operation monitoring, and further DAO tooling integrations.",
      "main_url": "https://www.palmeradao.xyz",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/logo-Palmera.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "e4c64dfd-c592-43d7-a3b7-7db4d606c239",
      "name": "Parcel",
      "description": "Parcel is a treasury and payment OS for DAOs and the contributor economy. Built atop Gnosis Safe, it sets to scale DAOs' and contributors' financial operations with features like payment requests, recurring/mass/CSV payouts, and nested multi-sigs.",
      "main_url": "https://parcel.money/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Parcel.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "1cf7c15b-6bb4-4343-a751-87864a89f9f5",
      "name": "Remox",
      "description": "Remox is a treasury, contribution and expenditure management tool made for DAOs. Its dashboards offer integrative, multi-wallet portfolio management, bookkeeping, accounting and insights, as well as contributor, payroll & bounties management, collaborative budgeting, investments and risk assessment.",
      "main_url": "https://www.remox.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Remox.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "c1cfde08-a7c1-4aed-9667-f916210a2d6f",
      "name": "Request",
      "description": "Request is a payments tool for direct, cross-bloackchain cryptocurrencies payments with minimal involvement of txn sides' information. Its invoices may designate any special terms and conditions.",
      "main_url": "https://request.network/en/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Request.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "c4109ae5-f3ac-40d8-ae2a-0705604d916e",
      "name": "Sablier",
      "description": "Sablier creates stable, constant streams of funds between crypto addresses and applications, serving different payments use cases. It is a product of the HiFi landing protocol.",
      "main_url": "https://sablier.finance/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Sablier.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "c45f1bcf-2d1c-4466-8521-839baec48767",
      "name": "Safe",
      "description": "Gnosis Safe is a cryptowallet with multiple signatures to approve transactions (multisig). It enhances funds security and offers DeFi and NFT integrations, often used by DAOs for treasury and management.",
      "main_url": "https://gnosis-safe.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Gnosis.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "8b0bc52c-aea1-406b-a55c-c427e5ff9b11",
      "name": "SafeSnap (Gnosis Safe / Snapshot)",
      "description": "SafeSnap is Gnosis Safe served by Snapshot voting. It allows DAOs to effortlessly implement their community's off-chain Snapshot decision as binding on-chain transactions on Gnosis Safes.",
      "main_url": "https://docs.snapshot.org/plugins/safesnap",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Safesnap.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "b5eed378-3ad7-427c-9149-2a75e2df28e6",
      "name": "Solv Protocol",
      "description": "Solv is a platform for minting and managing Financial NFTs - silos of digital assets tradable as vesting, bond, or other financial rights. It is designed to serve codeless, flexible setup for typical DAO operations, including fundraising, community-building, asset allocation and more.",
      "main_url": "https://solv.finance/home",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Logos_Tools_Solv.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "48b97478-d65d-4577-8ea9-592dcdf11dd6",
      "name": "Spect",
      "description": "Spect creates advanced workflows for DAOs. Its flexible no-code setup Forms integrate flow content, roles, milestones & rewards with relevant 0x addresses, and instantiate the needed smart contracts. Spect leverages its user profiles' documented resume' towards system sybil resistance.",
      "main_url": "https://spect.network/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Spect-logo3.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "27217215-609e-4097-a1d3-c7ca4552e431",
      "name": "Superfluid",
      "description": "Superfluid is an asset streaming protocol that brings subscriptions, salaries and rewards to DAOs and crypto-native businesses. Backed by an off-chain solvency network, it serves batch calls, adjustable agreements and a Reactor incubator for Best-evaluated ecosystem projects.",
      "main_url": "https://www.superfluid.finance/",
      "logo": "https://d33wubrfki0l68.cloudfront.net/492706482c9f1aebee7259b32cca255e31dee861/28f04/assets/img/logo.svg",
      "header": null,
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "36379525-6a2f-4ebf-93b7-db2c5bb9546d",
      "name": "TokenSets",
      "description": "TokenSets runs the permissionless Set asset management protocol, which integrates various DeFi products into strategizable investments/treasury portfolios.",
      "main_url": "https://www.tokensets.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Set.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "87e18a65-d542-4b4c-a409-a8286d653ee5",
      "name": "Token Tool",
      "description": "Token Tool is a one-stop app for multichain token operations. Users may create & manage tokens, automate payments, and track their portfolio via platform UI or API. DAO needs are further addressed by token crowdsales, drops and rich tokenization options.",
      "main_url": "https://tokentool.bitbond.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Logo+Bitbond.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "b2ca66d9-b709-4cbd-8f64-168bc7410240",
      "name": "Unique.vc",
      "description": "Unique Venture Clubs creates permissionless, no-code venture DAOs (Clubs) for liquidity pooling and joint asset governance. Clubs are governed by liquidity shares, roles, or NFT holdings. Unique's roadmap includes real-world assets investments and token-based platform governance.",
      "main_url": "https://unique.vc/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Unique.vc.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "05dae5ef-f31f-468f-9e90-ca974293d3cd",
      "name": "Unslashed",
      "description": "Unslashed is a decentralized insurance protocol for common crypto risks, collateralled by lilquidity pools. It is governed by its tokens holders through the Unslashed DAO.",
      "main_url": "https://unslashed.finance/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Unslashed.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "8d4cac8a-fb83-4329-8dc6-46160dbf0d3c",
      "name": "WEEZI",
      "description": "WEEZI is a DAO launcher built atop Aragon smart contracts, to allow simplified DAO creation. a product of the Berezka DAO and the Blockchain Industrial Alliance, it is set to serve asset reporting & management boards, sub-DAO structures, ragequit option and more.",
      "main_url": "https://weezi.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Logos_Tools_Weezi.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "66b2fb15-1a2c-4f17-b524-bdccdafcb48f",
      "name": "ZenithBlocks",
      "description": "ZenithBlocks builds transparent financial management for DAOs. Currently in alpha testing (Aug. 2023), it is set to synchronize DAO proposals with DAO budgets, to allow their seamless, automated, custom budget lines, on-chain implementation, payments and invoices.",
      "main_url": "https://www.zenithblocks.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/ZenithBlocks+Logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 8,
      "type": "category"
  },
  {
      "resource_id": "2774179f-2ff8-424e-8126-577abfe235c6",
      "name": "Aragon",
      "description": "Aragon is a platform for anyone to launch and manage DAOs. A lead launcher of thousands of DAOs since 2016, its 2023 OSx protocol and no-code App offer flexible and composable governance, treasury and management modules with seamless UI/UX.",
      "main_url": "https://aragon.org/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Aragon-logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "68339a6d-9491-4dd6-b747-c2d608459408",
      "name": "Chelo",
      "description": "Chelo develops ready-to-deploy financial tools to help DAOs attract, retain, and support their community. It facilitates collateralized loans to DAO members, uncollateralized loans to top contributors, peer-to-peer saving and borrowing (ROSCAs) and forthcoming DAO invoices.",
      "main_url": "https://chelo.fi/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Chelo.jpg",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "946e6070-46d4-4267-bf82-0b8fa71129d8",
      "name": "Commonwealth",
      "description": "Commonwealth serves management tools and 1-stop integration platform for on-chain discussion, propsal-making & voting products, including identity services and native crowdfunding.",
      "main_url": "https://commonwealth.im/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Commonwealth.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "ed74124c-dea7-40ec-b542-d0eefe4d7f05",
      "name": "Compound Governor",
      "description": "The Compound protocol is a DeFi pioneer in both financial producting and governance. Its simple-enough governance flow is used by some main(ly DeFi) DAOs. It includes user-set voting bars, voting delegation, execution delay, and an emergency function.",
      "main_url": "https://compound.finance/docs/governance",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-_Compound.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "3bdf4f20-064e-4e18-9603-aace5ef32168",
      "name": "Comp.Vote",
      "description": "Comp.Vote is a simple API service for Compound Finance token holders to vote and delegate protocol proposals on-chain with 0 gas fees. It applies community-built signature batching subsidized by the protocol. A parallel Uni.Vote is also deployed.",
      "main_url": "https://comp.vote",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-_Compound.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "2705d52e-df10-456e-b178-acd2149f8079",
      "name": "Coordinape",
      "description": "Coordinape is a tool for distributing individual rewards for contribution in a collective effort, based on peer judgement. A yearn.finance project, it currently serves grant-making and work payments.",
      "main_url": "https://coordinape.com ",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Coordinape.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "ac049d9f-b948-4448-baf5-1c9dc5666eb0",
      "name": "Council",
      "description": "Council is an on-chain governance framework to build and manage DAOs. Developed by the Element Finance team, it serves flexible governance structures with user-defined missions, strategies, permissions & roles, and builtin structures for more efficient DAO grants and rewards.",
      "main_url": "https://council.element.fi/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/COUNCIL_LOGO.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "1513c23a-7c0f-4e55-ac6d-f499269fcaf4",
      "name": "Curia Lab",
      "description": "Curia Lab is set to equip DAOs with data analytics and comprehensive tooling solutions. Its first flagship product (Mar. 2024) is Curia Governance Dashboard, designed to provide actionable insights into assessment, monitoring and optimization of governance strategies.",
      "main_url": "https://www.curialab.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Curia+Logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "f3084994-982a-48ec-8414-05db7e95c7d5",
      "name": "Discord",
      "description": "Discord offers a platform of multi-thread, media-rich content. It is widely used by DAOs for varied group and private communications, including as official part of decision-making.",
      "main_url": "https://www.discord.com",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Discord.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "76cd3b7d-8def-4257-b75f-476575d92387",
      "name": "Discourse",
      "description": "Discourse is a free, integrative platform for community discussions and signaling. Its 5-level trust system rewards participation with permissions. It is widely used by DAOs to deliberate, draft governance proposals, signal opinion and manage community attention. ",
      "main_url": "https://www.discourse.org/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Discourse.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "79cd5b4f-d926-45b0-abda-c2b5798ad8aa",
      "name": "Hats Protocol",
      "description": "Hats are programmable roles (represented on-chain as NFTs) that can provide the \"wearer\" with on-chain and off-chain permissions including workspace access, multisig signing authority, voting rights, and more. Hats can be granted, claimed, or revoked based on automatable eligibility criteria.",
      "main_url": "https://www.hatsprotocol.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/hats+hat+757x157+with+margin1.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "7675817c-b476-45f1-ace5-83e4adea4752",
      "name": "Llama",
      "description": "Llama produces a suite of products and services for DAO treasuries, including asset management & analysis, financial reporting and DAO-to-DAO financial interactions.",
      "main_url": "https://www.llama.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Illama.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "6a74822e-14a6-44b1-8858-efb4f4529860",
      "name": "Palmera",
      "description": "Palerma is a framework for simple, visualized DAO setup & management built atop Gnosis Safe integrations, modules, and hierarchies. Currently in alpha, it develops flexible structures for asset governance, role- and member-based permissions, operation monitoring, and further DAO tooling integrations.",
      "main_url": "https://www.palmeradao.xyz",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/logo-Palmera.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "8b0bc52c-aea1-406b-a55c-c427e5ff9b11",
      "name": "SafeSnap (Gnosis Safe / Snapshot)",
      "description": "SafeSnap is Gnosis Safe served by Snapshot voting. It allows DAOs to effortlessly implement their community's off-chain Snapshot decision as binding on-chain transactions on Gnosis Safes.",
      "main_url": "https://docs.snapshot.org/plugins/safesnap",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Safesnap.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "0dc1262d-55cb-4404-be43-518c79021899",
      "name": "Snapshot",
      "description": "Snapshot allows anyone to create an off-chain, gasless space to manage their own proposal-making and voting strategies based on on-chain registered voting shares.",
      "main_url": "https://snapshot.org/#/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Snapshot.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "48b97478-d65d-4577-8ea9-592dcdf11dd6",
      "name": "Spect",
      "description": "Spect creates advanced workflows for DAOs. Its flexible no-code setup Forms integrate flow content, roles, milestones & rewards with relevant 0x addresses, and instantiate the needed smart contracts. Spect leverages its user profiles' documented resume' towards system sybil resistance.",
      "main_url": "https://spect.network/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Spect-logo3.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "77e7266c-e691-4a5d-9572-531ee43f1646",
      "name": "Swae",
      "description": "Swae serves collaborative idea management and decision-making online, enhanced by AI sentiment analysis and proposal curation. Its DAO services currently include off-chain decision-making on grant crowdsourcing, with multiple on-chain & social integrations on its 2022-2023 roadmap.",
      "main_url": "https://swae.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Swae.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "e21e54b0-2203-46a6-b0ab-7f906caebbe2",
      "name": "Tally",
      "description": "Tally is a portal for Compound Governance DAOs, offering the a decision-making & management UI and an explorer for their activity and membership. It also serves educational materials and a newsletter focused on decentralized governance.",
      "main_url": "https://www.withtally.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Tally.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 4,
      "type": "category"
  },
  {
      "resource_id": "9b258a4e-1bc2-499b-8d9d-567cbc27f018",
      "name": "daobox",
      "description": "DAObox provides infrastructure solutions for decentralized organizations and Web3 communities, focusing on legal, financial, operational, and data aspects. DAObox Legal Wrapper service - is a formation and professional management of a dedicated legal wrapper for a DAO.",
      "main_url": "https://daobox.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/DAObox.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 41,
      "type": "category"
  },
  {
      "resource_id": "d1294c8d-4de3-4606-952f-86055b6dafc6",
      "name": "LexDAO",
      "description": "LexDAO is a non-profit association of legal engineers that interweives legacy Law and smart contracts. It offers a suite of Limited Liability Company wrappers for DAOs, and secure assets regulation.",
      "main_url": "https://www.lexdao.coop/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-LexDAO.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 41,
      "type": "category"
  },
  {
      "resource_id": "e8485a53-e30a-4b21-b922-1c9d3e000b7c",
      "name": "OpenLaw (Tribute)",
      "description": "OpenLaw is co-leader in merging legal standards with smart contracts, and co-founder of thereby legally official DAOs. It extends a legal engineering sandbox and the Tribute DAO launcher, with native legal and NFT modules.",
      "main_url": "https://www.openlaw.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-OpenLaw.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 41,
      "type": "category"
  },
  {
      "resource_id": "2774179f-2ff8-424e-8126-577abfe235c6",
      "name": "Aragon",
      "description": "Aragon is a platform for anyone to launch and manage DAOs. A lead launcher of thousands of DAOs since 2016, its 2023 OSx protocol and no-code App offer flexible and composable governance, treasury and management modules with seamless UI/UX.",
      "main_url": "https://aragon.org/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Aragon-logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "89f9e0fb-6379-4e50-b694-3d56ad03c0e7",
      "name": "Certik",
      "description": "Certik is a blockchain security firm that utilizes Formal Verification methods and AI technology to secure networks, smart contracts and applications. It currently BUIDLs its own network of security operators (\"Security Oracle\") to allow for real-time, decentralized code assessment.",
      "main_url": "https://www.certik.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Certik.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 45,
      "type": "category"
  },
  {
      "resource_id": "185c3ca9-bd63-495e-9df5-5e1f3cbcfa03",
      "name": "CharmVerse",
      "description": "CharmVerse is a Web3 operations platform for a simple creation and management of typical DAO tasks. Its current Beta serves Teams and project workspace dashboards, Web2/Web3 member profiles, offchain voting, role/token-gated content, and an NFT gallery.",
      "main_url": "https://www.charmverse.io/",
      "logo": "\n\t\t\thttps://static.wixstatic.com/media/1d6dff_76c31fc4660149aa95a5f619ea6a50a3~mv2.png/v1/fill/w_243,h_46,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/1d6dff_76c31fc4660149aa95a5f619ea6a50a3~mv2.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "185c3ca9-bd63-495e-9df5-5e1f3cbcfa03",
      "name": "CharmVerse",
      "description": "CharmVerse is a Web3 operations platform for a simple creation and management of typical DAO tasks. Its current Beta serves Teams and project workspace dashboards, Web2/Web3 member profiles, offchain voting, role/token-gated content, and an NFT gallery.",
      "main_url": "https://www.charmverse.io/",
      "logo": "\n\t\t\thttps://static.wixstatic.com/media/1d6dff_76c31fc4660149aa95a5f619ea6a50a3~mv2.png/v1/fill/w_243,h_46,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/1d6dff_76c31fc4660149aa95a5f619ea6a50a3~mv2.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 3,
      "type": "category"
  },
  {
      "resource_id": "68339a6d-9491-4dd6-b747-c2d608459408",
      "name": "Chelo",
      "description": "Chelo develops ready-to-deploy financial tools to help DAOs attract, retain, and support their community. It facilitates collateralized loans to DAO members, uncollateralized loans to top contributors, peer-to-peer saving and borrowing (ROSCAs) and forthcoming DAO invoices.",
      "main_url": "https://chelo.fi/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Chelo.jpg",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "7563d28f-4ee3-4106-9f6d-43d7acf425b2",
      "name": "Clique",
      "description": "Clique, of STP Network, allows simple DAO creation, governance and token-minting via users configuration of platform templates. Governance is bridged from Ethereum and executed on the Polygon blockchain. Project roadmap includes multi-chain governance and extension of governance methods.",
      "main_url": "https://myclique.io/#/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Clique+logo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "fa74b7d1-5755-4acc-a226-88535345d741",
      "name": "Collab.Land",
      "description": "Collab.Land offers integrated identification-as-human services on community social platforms, and management of such membership permissions according to tokenized parameters.",
      "main_url": "https://collab.land/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Collabland.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 5,
      "type": "category"
  },
  {
      "resource_id": "308a183d-e358-4c0e-b620-bce75d1f2f01",
      "name": "Colony",
      "description": "The Colony platform offers a free suite of tools to launch and run DAOs - Colonies, which make up Colony as a DAO-of-DAOs. Served capabilities include native DAO setting & launching, token issuing & selling, and flexible structure, attention & treasury management tools.",
      "main_url": "https://colony.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Colony.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "76cf9f5c-317b-4ec3-b689-660fd5661223",
      "name": "Common Ground",
      "description": "Common Ground is a Web3-native communication platform for individuals and communities. Featuring a reach onboarding layer, It serves human-identified 0x addresses with self-owned social experience and organizing tools including security, multimidia cords, roles, moderation, voting, and more.",
      "main_url": "https://www.commonground.cg/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/CoomonGround-logo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "76cf9f5c-317b-4ec3-b689-660fd5661223",
      "name": "Common Ground",
      "description": "Common Ground is a Web3-native communication platform for individuals and communities. Featuring a reach onboarding layer, It serves human-identified 0x addresses with self-owned social experience and organizing tools including security, multimidia cords, roles, moderation, voting, and more.",
      "main_url": "https://www.commonground.cg/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/CoomonGround-logo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 3,
      "type": "category"
  },
  {
      "resource_id": "946e6070-46d4-4267-bf82-0b8fa71129d8",
      "name": "Commonwealth",
      "description": "Commonwealth serves management tools and 1-stop integration platform for on-chain discussion, propsal-making & voting products, including identity services and native crowdfunding.",
      "main_url": "https://commonwealth.im/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Commonwealth.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 3,
      "type": "category"
  },
  {
      "resource_id": "ed74124c-dea7-40ec-b542-d0eefe4d7f05",
      "name": "Compound Governor",
      "description": "The Compound protocol is a DeFi pioneer in both financial producting and governance. Its simple-enough governance flow is used by some main(ly DeFi) DAOs. It includes user-set voting bars, voting delegation, execution delay, and an emergency function.",
      "main_url": "https://compound.finance/docs/governance",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-_Compound.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "ac049d9f-b948-4448-baf5-1c9dc5666eb0",
      "name": "Council",
      "description": "Council is an on-chain governance framework to build and manage DAOs. Developed by the Element Finance team, it serves flexible governance structures with user-defined missions, strategies, permissions & roles, and builtin structures for more efficient DAO grants and rewards.",
      "main_url": "https://council.element.fi/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/COUNCIL_LOGO.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 47,
      "type": "category"
  },
  {
      "resource_id": "1513c23a-7c0f-4e55-ac6d-f499269fcaf4",
      "name": "Curia Lab",
      "description": "Curia Lab is set to equip DAOs with data analytics and comprehensive tooling solutions. Its first flagship product (Mar. 2024) is Curia Governance Dashboard, designed to provide actionable insights into assessment, monitoring and optimization of governance strategies.",
      "main_url": "https://www.curialab.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Curia+Logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 47,
      "type": "category"
  },
  {
      "resource_id": "1513c23a-7c0f-4e55-ac6d-f499269fcaf4",
      "name": "Curia Lab",
      "description": "Curia Lab is set to equip DAOs with data analytics and comprehensive tooling solutions. Its first flagship product (Mar. 2024) is Curia Governance Dashboard, designed to provide actionable insights into assessment, monitoring and optimization of governance strategies.",
      "main_url": "https://www.curialab.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Curia+Logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 42,
      "type": "category"
  },
  {
      "resource_id": "bd4b7fd3-5226-4462-aa99-4b2e6062bf0b",
      "name": "DAOHause (Moloch)",
      "description": "DAOHause is Moloch DAOs' factory. Manufactured DAOs bear a set of minimaly viable functions, including ragequit, delegation and emergency. DAOHause is governed by holders of the HAUS token - moloch DAOs, their members and contributors.",
      "main_url": "https://daohaus.club/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-DaoHaus.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "f82b185e-cbae-42b4-9133-0340efe2f6e0",
      "name": "DeepDAO",
      "description": "DeepDAO collects and organizes a variety of quantitative and qualitative data about DAOs governance, their structure, people and decision-making. It currently serves interactive data dashboards, project descriptions, a DAO Tools go-to and a governerds' discord channel.",
      "main_url": "https://deepdao.io",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-DeepDao.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 3,
      "type": "category"
  },
  {
      "resource_id": "f82b185e-cbae-42b4-9133-0340efe2f6e0",
      "name": "DeepDAO",
      "description": "DeepDAO collects and organizes a variety of quantitative and qualitative data about DAOs governance, their structure, people and decision-making. It currently serves interactive data dashboards, project descriptions, a DAO Tools go-to and a governerds' discord channel.",
      "main_url": "https://deepdao.io",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-DeepDao.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 42,
      "type": "category"
  },
  {
      "resource_id": "f3084994-982a-48ec-8414-05db7e95c7d5",
      "name": "Discord",
      "description": "Discord offers a platform of multi-thread, media-rich content. It is widely used by DAOs for varied group and private communications, including as official part of decision-making.",
      "main_url": "https://www.discord.com",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Discord.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 3,
      "type": "category"
  },
  {
      "resource_id": "f3084994-982a-48ec-8414-05db7e95c7d5",
      "name": "Discord",
      "description": "Discord offers a platform of multi-thread, media-rich content. It is widely used by DAOs for varied group and private communications, including as official part of decision-making.",
      "main_url": "https://www.discord.com",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Discord.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 5,
      "type": "category"
  },
  {
      "resource_id": "9dcbb660-ec00-4275-b769-c2d57c885951",
      "name": "Enzyme",
      "description": "Enzyme is a council-led DAO controlling the Enzyme protocol for assets management, that is based on ready-made and user-strategized investment vaults. It offers DAOs a set of flexible capabilities to run their treasuries, currently leaning towards high-risk DeFi.",
      "main_url": "https://enzyme.finance//",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Enzyme.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "a808543c-422f-4155-ae8a-b58ff0dadca0",
      "name": "EtherMail",
      "description": "EtherMail is an e-mail service for blockchain wallets, building anonymous and encrypted communication among Web3 and Web2 addresses. Its targeted, tokenized mailing products may be triggered by on-chain events, and reward users for permitting reputation-based paid content.",
      "main_url": "https://ethermail.io/",
      "logo": "https://ethermail.io/images/logos/logo_ethermail_horizontal_primarydark.svg",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 3,
      "type": "category"
  },
  {
      "resource_id": "05d0b7c6-6867-4087-8b96-1f3b29a0b951",
      "name": "Gardens",
      "description": "Gardens is a launcher, management, discussion & documentation pack for DAOs, called Gardens. Gardens' governance is rooted in a coded constitution, conviction voting, consensus-building, and official dispute resolution.",
      "main_url": "https://gardens.1hive.org/#/home",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Gardens.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "3f26c598-41db-457f-8e38-35e89cb704b8",
      "name": "Hats Finance",
      "description": "Hats Finance is a decentralized bug bounty marketplace. It allows projects to create their native token bounty vaults, used to reward white hat hackers who successfully submit vulnerabilities in their codebase. Submissions are examined by the Hats` committee.",
      "main_url": "https://hats.finance/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Hats_Finance.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 45,
      "type": "category"
  },
  {
      "resource_id": "79cd5b4f-d926-45b0-abda-c2b5798ad8aa",
      "name": "Hats Protocol",
      "description": "Hats are programmable roles (represented on-chain as NFTs) that can provide the \"wearer\" with on-chain and off-chain permissions including workspace access, multisig signing authority, voting rights, and more. Hats can be granted, claimed, or revoked based on automatable eligibility criteria.",
      "main_url": "https://www.hatsprotocol.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/hats+hat+757x157+with+margin1.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 47,
      "type": "category"
  },
  {
      "resource_id": "c30f3faa-248b-45d6-82ab-8cf09acbe3f8",
      "name": "Immunefi",
      "description": "Immunefi runs a bug bounty platform to test and guard blockchain security, and specifically smart contracts. Its bounties are attended by a network of registered hackers. ",
      "main_url": "https://immunefi.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Imunify.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 45,
      "type": "category"
  },
  {
      "resource_id": "55fe57a8-6ff3-4ffa-9082-2eeff0f020a3",
      "name": "Kirobo",
      "description": "Kirobo develops decentralized applications for safer management of crypto assets. Set to enhance transaction validity and clarity and to reduce human errors, it serves personalized, non-custodian, DeFi-plugged Vaults with user-set wallets & passwords and retrieval functions.",
      "main_url": "https://www.kirobo.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Logos_Tools_Kirobo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "1eb044bf-a6ab-4ac2-ac08-355086c4a3d1",
      "name": "Kleros",
      "description": "Kleros is a crowdsourcing, smart contracts dispute resolution protocol, coupled with an Identity verification product. Its use cases currently include oracle, insurance, escrow and market translations  disputes.",
      "main_url": "https://kleros.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Kleros.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 46,
      "type": "category"
  },
  {
      "resource_id": "b341eda4-f367-4eb8-81fc-894a4d604488",
      "name": "Lomads",
      "description": "Lomads is an operations and finance management dashboard for web3 organizations. It serves transactions workflow automation (e.g., bounties, recurring / batch / milestone-based payments); and mints organizations' Soul-Bound Tokens, with applicable roles & permissions across integrated Web2 / Web3 apps.",
      "main_url": "https://www.lomads.co/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Lomads_DeepDAO.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 47,
      "type": "category"
  },
  {
      "resource_id": "c7828cc4-3f41-4013-9823-b6a810e786a1",
      "name": "Mailchain",
      "description": "Mailchain is a platform to send and receive messages directly between blockchain wallets. It allows cross-protocol communication, with user-owned mailbox and messages (1:1, 1:many), password, end-to-end encryption and decentralized storage for enhanced privacy.",
      "main_url": "https://mailchain.com/",
      "logo": "https://uploads-ssl.webflow.com/6193af32c4bb83588771612b/63163cdf369f8ad33461205d_mc-logo.svg",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 3,
      "type": "category"
  },
  {
      "resource_id": "1d863942-25ab-421c-9b15-e305007bb18d",
      "name": "Mirror",
      "description": "Mirror is a writers' collective, ideating and community-building through Web3 media & publications. Participation is NFT-based and content may be easily NFT-minted and managed on-platform by its creators.",
      "main_url": "https://mirror.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Mirror.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 5,
      "type": "category"
  },
  {
      "resource_id": "1d863942-25ab-421c-9b15-e305007bb18d",
      "name": "Mirror",
      "description": "Mirror is a writers' collective, ideating and community-building through Web3 media & publications. Participation is NFT-based and content may be easily NFT-minted and managed on-platform by its creators.",
      "main_url": "https://mirror.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Mirror.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 44,
      "type": "category"
  },
  {
      "resource_id": "1ed83197-4321-42e6-8a3d-e6b875980e83",
      "name": "Multifarm",
      "description": "Multifarm is a DeFi data platform that builds customizable dashboards for protocols and DAOs. It offers DAO treasury boards including revenue streams, assets and strategies; varied, time-series yield options and analytics; and tailor-made DeFi schemas for client protocols.",
      "main_url": "https://www.multifarm.fi/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Mulitfarm.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "1ed83197-4321-42e6-8a3d-e6b875980e83",
      "name": "Multifarm",
      "description": "Multifarm is a DeFi data platform that builds customizable dashboards for protocols and DAOs. It offers DAO treasury boards including revenue streams, assets and strategies; varied, time-series yield options and analytics; and tailor-made DeFi schemas for client protocols.",
      "main_url": "https://www.multifarm.fi/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Mulitfarm.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 42,
      "type": "category"
  },
  {
      "resource_id": "55e9f0d1-e9dd-42cc-82c5-d1fbef9a16ff",
      "name": "Muse DAO",
      "description": "Muse DAO is an NFT venture builder DAO focused on building decentralized applications to further the NFT space. Its dapps - currently still unaudited (Aug. 2023) - serve a swift dapp building UI, open & liquid NFT minting, NFT DeFi operations, and more.",
      "main_url": "https://musedao.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Muse+dao+-+tool+logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 47,
      "type": "category"
  },
  {
      "resource_id": "55e9f0d1-e9dd-42cc-82c5-d1fbef9a16ff",
      "name": "Muse DAO",
      "description": "Muse DAO is an NFT venture builder DAO focused on building decentralized applications to further the NFT space. Its dapps - currently still unaudited (Aug. 2023) - serve a swift dapp building UI, open & liquid NFT minting, NFT DeFi operations, and more.",
      "main_url": "https://musedao.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Muse+dao+-+tool+logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 39,
      "type": "category"
  },
  {
      "resource_id": "e77d5e8e-7d7c-44b3-ba02-287b602e15d8",
      "name": "Nexus Mutual",
      "description": "Nexus Mutual supplies on-chain insurance through liquidity pools and decentralized validation of customers' claims. Governed by permissioned NXM token holders, it currently covers smart contracts risks and aims further.",
      "main_url": "https://nexusmutual.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-NExus.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "16ad0e7e-e3c5-4ab0-815b-0ecdeaab5e0d",
      "name": "Octav",
      "description": "Octav is a web3 treasury management, analytics tool and on-chain data provider. It turns the full data of user accounts into live portfolio boards, integrative reports and API endpoints, tagged and tailored for easy management and official reporting.",
      "main_url": "https://octav.fi/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Octav.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 42,
      "type": "category"
  },
  {
      "resource_id": "c4ae6c29-9ebf-490a-9d38-34b320541937",
      "name": "Opencord",
      "description": "Opencord is a Web3 social platform built for DAOs. It offers log-in DAO servers with discussion cords, audio channels, DM chats, tokenized access tiers, integrated feeds and Snapshot governance. Currently in Public Beta, it builds to go opensource during 2023.",
      "main_url": "https://www.opencord.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Opencord.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 3,
      "type": "category"
  },
  {
      "resource_id": "c4ae6c29-9ebf-490a-9d38-34b320541937",
      "name": "Opencord",
      "description": "Opencord is a Web3 social platform built for DAOs. It offers log-in DAO servers with discussion cords, audio channels, DM chats, tokenized access tiers, integrated feeds and Snapshot governance. Currently in Public Beta, it builds to go opensource during 2023.",
      "main_url": "https://www.opencord.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Opencord.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 5,
      "type": "category"
  },
  {
      "resource_id": "e8485a53-e30a-4b21-b922-1c9d3e000b7c",
      "name": "OpenLaw (Tribute)",
      "description": "OpenLaw is co-leader in merging legal standards with smart contracts, and co-founder of thereby legally official DAOs. It extends a legal engineering sandbox and the Tribute DAO launcher, with native legal and NFT modules.",
      "main_url": "https://www.openlaw.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-OpenLaw.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "1f70242b-9d52-455d-b6ff-0266a9a89b74",
      "name": "OpenZeppelin",
      "description": "Open Zeppelin provides security products for decentralized applications. Its library of modular, reusable smart contracts for Ethereum (on Solidty) is used widely across DeFi and DAOs. It serves its own platform for automated administration and coding of smart contracts in a private, security-prioritizing environment; and contract auditing.",
      "main_url": "https://openzeppelin.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-OpenZepplin.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 45,
      "type": "category"
  },
  {
      "resource_id": "a3887541-a4ee-4f43-96ed-4bb5221d0866",
      "name": "Origami",
      "description": "Origami is a DAO Launcher oriented towards swift launching and DAO sustainable growth. It serves guidance and consultation through community & blockchain setup, funding frameworks and possible seed money, a distinct governance model, private groups and legal compliance for its DAOs.",
      "main_url": "https://joinorigami.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Origami.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "6a74822e-14a6-44b1-8858-efb4f4529860",
      "name": "Palmera",
      "description": "Palerma is a framework for simple, visualized DAO setup & management built atop Gnosis Safe integrations, modules, and hierarchies. Currently in alpha, it develops flexible structures for asset governance, role- and member-based permissions, operation monitoring, and further DAO tooling integrations.",
      "main_url": "https://www.palmeradao.xyz",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/logo-Palmera.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 47,
      "type": "category"
  },
  {
      "resource_id": "13e44afb-26aa-40bc-b40a-ccc953a0ecbb",
      "name": "Pessimistic",
      "description": "Pessimistic provides security audits of smart contracts, DeFi platforms and blockchain networks, as well as Blockchain security consultancy and education. It explicitly addresses Blockchain startups, with quite a few DAOs already on its list of audits.",
      "main_url": "https://pessimistic.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Pessimistic.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 45,
      "type": "category"
  },
  {
      "resource_id": "3d3f628d-63d7-42d1-bfd6-a12ae2b2aebf",
      "name": "POAP",
      "description": "POAP introduces a decentralized network of Identity verification that relies on individuals' combined collections of tokened Proofs of Attendance in events hosted by verified POAP partners. ",
      "main_url": "https://poap.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Poap.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 3,
      "type": "category"
  },
  {
      "resource_id": "c1cfde08-a7c1-4aed-9667-f916210a2d6f",
      "name": "Request",
      "description": "Request is a payments tool for direct, cross-bloackchain cryptocurrencies payments with minimal involvement of txn sides' information. Its invoices may designate any special terms and conditions.",
      "main_url": "https://request.network/en/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Request.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 30,
      "type": "tag"
  },
  {
      "resource_id": "c1cfde08-a7c1-4aed-9667-f916210a2d6f",
      "name": "Request",
      "description": "Request is a payments tool for direct, cross-bloackchain cryptocurrencies payments with minimal involvement of txn sides' information. Its invoices may designate any special terms and conditions.",
      "main_url": "https://request.network/en/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Request.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 29,
      "type": "tag"
  },
  {
      "resource_id": "c4109ae5-f3ac-40d8-ae2a-0705604d916e",
      "name": "Sablier",
      "description": "Sablier creates stable, constant streams of funds between crypto addresses and applications, serving different payments use cases. It is a product of the HiFi landing protocol.",
      "main_url": "https://sablier.finance/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Sablier.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 29,
      "type": "tag"
  },
  {
      "resource_id": "c4109ae5-f3ac-40d8-ae2a-0705604d916e",
      "name": "Sablier",
      "description": "Sablier creates stable, constant streams of funds between crypto addresses and applications, serving different payments use cases. It is a product of the HiFi landing protocol.",
      "main_url": "https://sablier.finance/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Sablier.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 30,
      "type": "tag"
  },
  {
      "resource_id": "b5eed378-3ad7-427c-9149-2a75e2df28e6",
      "name": "Solv Protocol",
      "description": "Solv is a platform for minting and managing Financial NFTs - silos of digital assets tradable as vesting, bond, or other financial rights. It is designed to serve codeless, flexible setup for typical DAO operations, including fundraising, community-building, asset allocation and more.",
      "main_url": "https://solv.finance/home",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Logos_Tools_Solv.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 39,
      "type": "category"
  },
  {
      "resource_id": "b5eed378-3ad7-427c-9149-2a75e2df28e6",
      "name": "Solv Protocol",
      "description": "Solv is a platform for minting and managing Financial NFTs - silos of digital assets tradable as vesting, bond, or other financial rights. It is designed to serve codeless, flexible setup for typical DAO operations, including fundraising, community-building, asset allocation and more.",
      "main_url": "https://solv.finance/home",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Logos_Tools_Solv.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "fa8ffd25-8164-4171-8ccf-0513740d239c",
      "name": "SubDAO",
      "description": "SubDAO is a multi-chain DAO protocol for managing digital assets through signatures, voting, and decentralized features. It is set to provide widely applicable DAO tools in venture capital, serving fundraising, DeFi integrations for swaps, NFT trading, and liquidity lending.",
      "main_url": "https://www.subdao.network/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/SubDao.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "fa8ffd25-8164-4171-8ccf-0513740d239c",
      "name": "SubDAO",
      "description": "SubDAO is a multi-chain DAO protocol for managing digital assets through signatures, voting, and decentralized features. It is set to provide widely applicable DAO tools in venture capital, serving fundraising, DeFi integrations for swaps, NFT trading, and liquidity lending.",
      "main_url": "https://www.subdao.network/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/SubDao.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "e21e54b0-2203-46a6-b0ab-7f906caebbe2",
      "name": "Tally",
      "description": "Tally is a portal for Compound Governance DAOs, offering the a decision-making & management UI and an explorer for their activity and membership. It also serves educational materials and a newsletter focused on decentralized governance.",
      "main_url": "https://www.withtally.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Tally.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 42,
      "type": "category"
  },
  {
      "resource_id": "125e9592-fb37-4363-ab6b-59b62fae8af1",
      "name": "The DAOist",
      "description": "The DAOist is an active DAO ecosystem collaboration for online and offline DAO-related events, media and community-building.",
      "main_url": "https://www.thedaoist.co/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-The_DAOist.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 5,
      "type": "category"
  },
  {
      "resource_id": "6d82378e-9823-4f7c-87a8-e939be320e27",
      "name": "TogetherCrew",
      "description": "TogetherCrew fosters healthy DAO communities utilizing rich DAO data. Its analysis captures DAO members, relationships, cliques & community as interdependent ecosystems collaborating in the wider DAO context. Its first feature is a community calendar with automated information of members' activity timing.",
      "main_url": "https://togethercrew.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/TogetherCrew.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 42,
      "type": "category"
  },
  {
      "resource_id": "36379525-6a2f-4ebf-93b7-db2c5bb9546d",
      "name": "TokenSets",
      "description": "TokenSets runs the permissionless Set asset management protocol, which integrates various DeFi products into strategizable investments/treasury portfolios.",
      "main_url": "https://www.tokensets.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Set.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "87e18a65-d542-4b4c-a409-a8286d653ee5",
      "name": "Token Tool",
      "description": "Token Tool is a one-stop app for multichain token operations. Users may create & manage tokens, automate payments, and track their portfolio via platform UI or API. DAO needs are further addressed by token crowdsales, drops and rich tokenization options.",
      "main_url": "https://tokentool.bitbond.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Logo+Bitbond.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 39,
      "type": "category"
  },
  {
      "resource_id": "bd4dcb6e-467d-4585-b005-a063c73ff2c7",
      "name": "Unika",
      "description": "Unika is decentralized anonymous identity protocol. It provides privacy-preserving sybil-resistant user verification. Thus, upon dApp request and user's consent, Unika checks users’ eligibility and uniqueness. User's privacy is saved by delivering only yes/no answers about the user to dApp.",
      "main_url": "https://unika.network/main",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Unika-logo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 45,
      "type": "category"
  },
  {
      "resource_id": "40a0280f-b3cd-410c-80e4-ff50fdee7dba",
      "name": "VOLBOOST",
      "description": "VOLBOOST is a multichain trading bot working to increase market activity and spread of users' crypto tokens. The bot boosts trading volume up to x200 by splitting single investments into multiple trades, which are promoted via platform socials.",
      "main_url": "https://volboost.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/volboost.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "40a0280f-b3cd-410c-80e4-ff50fdee7dba",
      "name": "VOLBOOST",
      "description": "VOLBOOST is a multichain trading bot working to increase market activity and spread of users' crypto tokens. The bot boosts trading volume up to x200 by splitting single investments into multiple trades, which are promoted via platform socials.",
      "main_url": "https://volboost.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/volboost.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 47,
      "type": "category"
  },
  {
      "resource_id": "5daeffe6-05d8-42e1-839a-d68adf45ae54",
      "name": "WalletChat",
      "description": "WalletChat is a 0x wallet-to-wallet messaging app and browser extension. It enables 0x messaging inside integrated websites, community messaging, and ready social API/widget integrations for dApps, marketplaces, games and wallets.",
      "main_url": "https://www.walletchat.fun/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/Walletchat.PNG",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 3,
      "type": "category"
  },
  {
      "resource_id": "aaba3e68-6439-4b54-8ce3-895da5566176",
      "name": "Wonderverse",
      "description": "Wonderverse is a project management platform for DAOs and a DAO launcher. Individual users may join partnering DAOs` grants, tasks and other communications & offerings, all dashboard-aggregated and presented for their Web3 resume.",
      "main_url": "https://www.wonderverse.xyz/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/wonderlogo.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "0346554b-7165-4e45-bbeb-b9f6176f74c2",
      "name": "XDAO",
      "description": "XDAO is a no-code DAO launcher for EVM-compatible blockchain networks, focused on investments. It offers a native suit of tools for treasury management & operation and mixed on-/off-chain voting system to save gas fees. It currently BUIDLs a palette of modules to enrich governance and other DAO utilities.",
      "main_url": "https://www.xdao.app/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-XDao.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "4f8b93d2-d09c-4a2e-825a-76236e0ea757",
      "name": "Zapper",
      "description": "Zapper is a multi-chain platform for crypto portfolio management and investments. Its vast range of supported trading options (in DeFi & NFTs) importantly includes Zapped trades: smart contract shortcuts to selected, complex investment paths. In May 2022, it introduced (team-reviewed) self-listing of dapp Zapper integrations.",
      "main_url": "https://www.zapper.fi/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/zapper.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header-Bk_Tool_Box.jpg",
      "category_id": 10,
      "type": "category"
  },
  {
      "resource_id": "66b2fb15-1a2c-4f17-b524-bdccdafcb48f",
      "name": "ZenithBlocks",
      "description": "ZenithBlocks builds transparent financial management for DAOs. Currently in alpha testing (Aug. 2023), it is set to synchronize DAO proposals with DAO budgets, to allow their seamless, automated, custom budget lines, on-chain implementation, payments and invoices.",
      "main_url": "https://www.zenithblocks.com/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/ZenithBlocks+Logo.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 47,
      "type": "category"
  },
  {
      "resource_id": "8db06297-111a-47f2-9029-42d1bb230080",
      "name": "Zodiac",
      "description": "Gnosis's pack of developer-focused DAO tools, based on Gnosis Safe. Its main features include on-chain execution of off-chain voting, a cross-chain DAO agency, a Moloch integrator, and a module for flexible imported governance methods.",
      "main_url": "https://github.com/gnosis/zodiac",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/logo-Zodiac.webp",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": 1,
      "type": "category"
  },
  {
      "resource_id": "127e6626-742e-492d-a775-6f54945733c1",
      "name": "DeXe DAO Studio",
      "description": "DeXe DAO Studio is DAO-governed infrastructure & seamless interface for creating and managing DAOs. Built upon DeXe Protocol of DAO smart contracts (on BNB Chain + other L2s forthcoming), it offers rich, custom configurations of DAO structures, governance, treasury and tokenization.",
      "main_url": "https://www.dexe.io/",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Dexe+logo+-+wide+transparent.png",
      "header": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/ecosystems/logo/header_Bk_Tool.svg",
      "category_id": null,
      "type": null
  }
];


export const daoCategoryMock = [
  {
      "id": 2,
      "name": "Governance Server",
      "description": null,
      "parent_id": null,
      "is_active": false,
      "type": "tag",
      "created_at": "2021-09-09T13:52:14.170Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 15,
      "name": "Insurance",
      "description": null,
      "parent_id": null,
      "is_active": false,
      "type": "tag",
      "created_at": "2021-09-09T13:56:08.349Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 19,
      "name": "Privacy",
      "description": null,
      "parent_id": null,
      "is_active": false,
      "type": "tag",
      "created_at": "2021-09-09T13:56:08.349Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 20,
      "name": "Resume'",
      "description": null,
      "parent_id": null,
      "is_active": false,
      "type": "tag",
      "created_at": "2021-09-09T13:56:08.349Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 23,
      "name": "Reputation Service",
      "description": null,
      "parent_id": null,
      "is_active": false,
      "type": "tag",
      "created_at": "2021-09-09T13:57:49.689Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 29,
      "name": "Payments",
      "description": null,
      "parent_id": null,
      "is_active": false,
      "type": "tag",
      "created_at": "2021-09-09T13:59:12.215Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 30,
      "name": "Accounting",
      "description": null,
      "parent_id": null,
      "is_active": false,
      "type": "tag",
      "created_at": "2021-09-09T13:59:12.215Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 35,
      "name": "Dispute Resolution",
      "description": null,
      "parent_id": null,
      "is_active": false,
      "type": "tag",
      "created_at": "2021-09-09T13:59:12.215Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 37,
      "name": "What is a DAO?",
      "description": null,
      "parent_id": null,
      "is_active": false,
      "type": "tag",
      "created_at": "2021-09-09T13:59:59.660Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 45,
      "name": "Security & Privacy",
      "description": "Keep DAO and members’ software & data from harm’s way",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-10-11T08:34:23.095Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 41,
      "name": "Legal",
      "description": "Apply real-lifel legal structures to smart contracts",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-10-11T08:34:23.095Z",
      "updated_by": null,
      "order": 60
  },
  {
      "id": 42,
      "name": "Analytics",
      "description": "Analysing DAOs and their ecosystems through research data",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-10-11T08:34:23.095Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 10,
      "name": "DeFi",
      "description": "Put Decentralized Finance to the service of DAO needs",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-09-09T13:54:31.140Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 46,
      "name": "Dispute Resolution",
      "description": "Network algorithm solutions to smart contracts disputes",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-10-14T09:06:13.804Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 4,
      "name": "Governance",
      "description": "Facilitate deliberation and decision-making in DAOs",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-09-09T13:52:14.170Z",
      "updated_by": null,
      "order": 50
  },
  {
      "id": 6,
      "name": "Infrastructure",
      "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-12-28T14:00:55.203Z",
      "updated_by": null,
      "order": 30
  },
  {
      "id": 39,
      "name": "NFTs",
      "description": "Serve NFT communities, NFTs as bootstrap, setup, management tools for DAOs",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-10-11T08:34:23.095Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 8,
      "name": "Treasury",
      "description": "Facilitate DAO asset management",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-09-09T13:54:31.140Z",
      "updated_by": null,
      "order": 40
  },
  {
      "id": 43,
      "name": "Identity & Reputation",
      "description": "Produce verified Web3 identification and documented experience",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-10-11T08:34:23.095Z",
      "updated_by": null,
      "order": 20
  },
  {
      "id": 5,
      "name": "Media & Communications",
      "description": "Build and run media channels, journalism, PR, communication platforms for DAOs",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-12-28T13:44:02.876Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 44,
      "name": "Arts & Culture",
      "description": "Serve DAO artist, art tech. & markets, ecosystem ideation & meme'ing",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-10-11T08:34:23.095Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 3,
      "name": "Web3 Socials",
      "description": "Build and operate tools for communication between blockchain addresses",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2022-12-02T12:02:25.182Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 47,
      "name": "Up-and-coming",
      "description": "Any DAO tools in alpha, beta, or onboarding v1.0 stages",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2022-08-22T13:20:22.402Z",
      "updated_by": null,
      "order": 1000
  },
  {
      "id": 1,
      "name": "DAO Launcher",
      "description": "Launching DAOs with operaticve governance and treasury",
      "parent_id": null,
      "is_active": true,
      "type": "category",
      "created_at": "2021-09-09T13:52:14.170Z",
      "updated_by": null,
      "order": 1000
  }
]